import React from 'react';
import { CodeOutlined } from '@ant-design/icons';

const UzyToolCommand: React.FC<{ content: string }> = ({ content }) => (
  <div className="chat-command-card">
    <div className="chat-command-card-header"><CodeOutlined /> 执行命令</div>
    <div className="chat-command-card-body">{content.trim()}</div>
  </div>
);

export default UzyToolCommand;
